<template>
  <v-row align="center">
    <v-col cols="8">
      <v-select
        outlined
        hide-details
        dense
        item-value="id"
        item-text="title"
        multiple
        no-data-text="Список пуст"
        :items="entities"
        :value="value"
        :disabled="$apollo.queries.entities.loading"
        :loading="$apollo.queries.entities.loading"
        @click="$apollo.queries.entities.refetch()"
        @change="$emit('input', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
import availableEntities from '@/components/dynamic-list-items/widgets/feeds/inputs/availableEntities.js'
export default {
  name: 'RelationWidgetInput',
  props: {
    value: {
      type: [Array, String],
      default: () => []
    },
    entity: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      entities: []
    }
  },
  apollo: {
    entities: {
      fetchPolicy: 'network-only',
      query () {
        return this.entity ? availableEntities[this.entity] : availableEntities.default
      },
      skip () {
        return !this.entity
      },
      variables () {
        return { where: {} }
      },
      update (data) {
        this.entities = data[this.entity]
      },
      result ({ data }) {
        this.entities = data[this.entity].list
      }
    }
  }
}
</script>
